import React from 'react';
import './HouseDesign.css';
import useScrollToTop from '../components/useScrollToTop';// Use the same CSS file
import ReusableLanding from '../components/ReusableLanding'
import image2 from '../img/exterior.webp'
import GetQuoteForm from '../components/GetQuoteForm';
import ReusableSteps from '../components/ReusableSteps';
import FAQ from '../components/FAQ';
import HouseplanfaqData from '../components/Houseplanfaqdata';
import { FaHardHat, FaDraftingCompass, FaBuilding, FaBolt, FaTint, FaPaintRoller, FaTree ,FaCheckSquare, FaThermometerHalf } from 'react-icons/fa'; // Import relevant icons
import WhyChooseUs from '../components/WhyChooseUs';


const HouseConstruction = () => {
    useScrollToTop();
    const stepsData = [
        {
            title: 'Tell us your requirements',
            description: 'Share your requirements for a dream home by submitting the enquiry form or calling our help line number: 75960 58808. We’re always available and happy to hear you out.',
        },
        {
            title: 'Discuss several ideas',
            description: 'Our experts will evaluate your house design requirements, and share several input and ideas with you. Think of it as a brainstorming session to finalize your design requirements.',
        },
        {
            title: 'Drawing and designing',
            description: 'Based on the ideas we discuss together, our experts will start working on your house design project. Within a few days, we will send you the concept drawings for reviews.',
        },
        {
            title: 'Revisions and modifications',
            description: 'We want to give you the design that you fully like and that may require some revisions and modifications in what we create. You can request revisions and changes.',
        },
        {
            title: 'Approval and delivery',
            description: 'Once you are fully satisfied with the design created by our expert architects and 3D house designers, we’ll deliver the designs digitally so that you can start building.',
        },
        {
            title: 'Online support',
            description: 'Our relationship does not end with delivery. We’ll be around and you can write or call us anytime even during the execution if needed.',
        },
        // Add as many steps as needed
    ];
    return (
        <>
        <ReusableLanding
        imageUrl={image2}
        title="House Construction"
        description=" Building your dream home is a significant undertaking. At Housekaar, we provide comprehensive house construction services, ensuring quality, efficiency, and a seamless building process."
    />
        <div className="house-design-page">
            <section className="construction-services">
                <h2>Our Comprehensive Construction Services</h2>
                <p>We offer a complete suite of construction services to bring your architectural vision to life. Our experienced team manages every phase of the building process with precision and care.</p>
                <div className="service-details-grid">
                    <div className="service-item">
                        <FaHardHat className="service-icon" />
                        <h3>Project Management</h3>
                        <p>Our dedicated project managers oversee all aspects of your construction project, including scheduling, budgeting, vendor coordination, and quality control, ensuring a smooth and stress-free experience.</p>
                    </div>
                    <div className="service-item">
                        <FaBuilding className="service-icon" />
                        <h3>Foundation and Structure</h3>
                        <p>We lay a solid foundation for your home, ensuring structural integrity and longevity. Our expertise includes various foundation types and robust structural frameworks built to the highest safety standards.</p>
                    </div>
                    <div className="service-item">
                        <FaBolt className="service-icon" />
                        <h3>Electrical Systems</h3>
                        <p>Our certified electricians install safe and efficient electrical systems, including wiring, lighting fixtures, power outlets, and distribution panels, adhering to all relevant codes and standards.</p>
                    </div>
                    <div className="service-item">
                        <FaTint className="service-icon" />
                        <h3>Plumbing Systems</h3>
                        <p>We design and install reliable plumbing systems for water supply, drainage, and sewage disposal. Our plumbers ensure proper installation and compliance with hygiene and safety regulations.</p>
                    </div>
                    <div className="service-item">
                    <FaThermometerHalf className="service-icon"/>
                        <h3>HVAC Systems</h3>
                        <p>We integrate efficient heating, ventilation, and air conditioning (HVAC) systems to ensure optimal comfort and energy efficiency within your home, tailored to the local climate and your preferences.</p>
                    </div>
                    <div className="service-item">
                        <FaPaintRoller className="service-icon" />
                        <h3>Interior and Exterior Finishing</h3>
                        <p>Our skilled craftsmen handle all interior and exterior finishing work, including plastering, painting, flooring, tiling, roofing, cladding, and facade work, paying close attention to detail and aesthetics.</p>
                    </div>
                    <div className="service-item">
                        <FaDraftingCompass className="service-icon" />
                        <h3>Custom Design Adjustments During Construction</h3>
                        <p>While we aim for perfection in the planning phase, we understand that minor adjustments might be needed during construction. Our flexible approach allows for certain design modifications to accommodate your evolving needs.</p>
                    </div>
                    <div className="service-item">
                        <FaTree className="service-icon" />
                        <h3>Landscaping and Outdoor Spaces</h3>
                        <p>We extend our services beyond the house itself, offering landscaping design and implementation to create beautiful and functional outdoor spaces that complement your new home.</p>
                    </div>
                    <div className="service-item">
                        <FaCheckSquare className="service-icon" />
                        <h3>Quality Assurance and Inspections</h3>
                        <p>Throughout the construction process, we conduct rigorous quality assurance checks and coordinate with relevant authorities for necessary inspections to ensure compliance and the highest standards of workmanship.</p>
                    </div>
                </div>
            </section>

            <WhyChooseUs/>
            

            <section style={{ padding: '0px 20px' }}>
                <h2>Get Started on Your Dream Home</h2>
                <p>
                    Ready to take the next step in building your dream home? Contact us today for a consultation and let our expert team guide you through the entire construction process.
                </p>
            </section>
            <ReusableSteps steps={stepsData} />
        </div>

        <GetQuoteForm/>
        <FAQ faqData={HouseplanfaqData} />

        </>
    );
};

export default HouseConstruction;